import * as types from './types';

// Note: billing is now in the billing slice (state.billing)
const initialState = {
  openSupportDialog: false,
  planInfo: null,
  subscriptionInfo: null,
  accountUsage: null,
  openPopups: {
    upgradePlan: false,
    rechargeAccount: false
  },
  refreshPlanInfoIndex: 0
};

const drawerReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_OPEN_SUPPORT_DIALOG:
      return { ...state, openSupportDialog: action.payload };
    case types.SET_PLAN_INFO:
      return { ...state, planInfo: action.payload };
    case types.SET_SUBSCRIPTION_INFO:
      return { ...state, subscriptionInfo: action.payload };
    case types.SET_ACCOUNT_USAGE:
      return { ...state, accountUsage: action.payload };
    case types.SET_UPGRADE_POPUP:
      return {
        ...state,
        openPopups: { ...state.openPopups, upgradePlan: action.payload }
      };
    case types.SET_RECHARGE_POPUP:
      return {
        ...state,
        openPopups: { ...state.openPopups, rechargeAccount: action.payload }
      };
    case types.REFRESH_PLAN_INFO:
      return { ...state, refreshPlanInfoIndex: action.payload };
    default:
      return state;
  }
};

export default drawerReducer;